import { useEffect, useState } from 'react';
import { Formik } from 'formik';
import * as Yup from 'yup';
import Button from '../../../components/form-control/Button';
import { assignLead, getAllAdminAccounts } from '../../../api/requests';
import SelectDropdown, {
  ISelectDropdownItem
} from '../../../components/form-control/SelectDropdown';
import { getFormattedAccessRight } from '../../../utils/miscFunctions';
import { showToast } from '../../../utils/miscFunctions';

export interface IAssignLead {
  adminEmail: string;
}

const AssignLead = ({
  onProceed,
  onClose,
  leadData
}: {
  onProceed: () => void;
  onClose: () => void;
  leadData: any;
}) => {
  const [loading, setLoading] = useState<boolean>(false);
  const [submitting, setSubmitting] = useState<boolean>(false);
  const [admins, setAdmins] = useState<any>([]);

  const submitHandler = (values: any) => {
    const id: string = leadData?.id;
    setSubmitting(true);
    assignLead(id, values.adminEmail)
      .then((response: any) => {
        showToast.success(response?.message ?? `Lead assigned to admin successfully`);
        onProceed();
      })
      .catch((error: any) => {
        showToast.error(error.description);
      })
      .finally(() => {
        setSubmitting(false);
      });
  };

  useEffect(() => {
    getAllAdmins();
  }, []);

  const getAllAdmins = (page = 0) => {
    getAllAdminAccounts()
      .then((response: any) => {
        const _admins = response?.map((admin: any) => ({
          name: `${admin.firstName} ${admin.lastName} (${getFormattedAccessRight(
            admin.accessRight
          )})`,
          value: admin.email
        }));
        setAdmins(_admins);
      })
      .catch((error: Error) => { });
  };
  
  return (
    <div className="bg-white rounded-xl">
      <div className="flex items-center px-5 mt-[26px]">
        <span>This lead will be assigned to the admin you select</span>
      </div>

      <div className="p-[1rem] w-full">
        <Formik
          initialValues={{
            adminEmail: ''
          }}
          validateOnChange={false}
          validateOnBlur={false}
          validationSchema={Yup.object({})}
          onSubmit={(values) => {
            submitHandler(values);
          }}>
          {({ values, errors, handleSubmit, handleChange, setFieldValue, handleBlur, touched }) => (
            <form className="space-y-4" onSubmit={handleSubmit}>
              <div className="">
                <SelectDropdown
                  label="Admins"
                  name="adminEmail"
                  list={admins}
                  listSelectedValue={values.adminEmail}
                  onChange={(val: ISelectDropdownItem | null) => {
                    setFieldValue('adminEmail', val);
                  }}
                  search
                  searchPlaceHolder='Search by name'
                  onBlur={handleBlur}
                  placeholder="Select an admin"
                  error={touched.adminEmail ? errors.adminEmail : undefined}
                  helperText={touched?.adminEmail ? errors.adminEmail : undefined}
                  required
                />
              </div>

          
               <div className="w-full flex gap-4 mt-6 !mb-4">
                <Button
                  label="Cancel"
                  onClick={onClose}
                  bgColor='secondary'
                  fullWidth
                  loading={submitting}
                  disabled={submitting}
                />
                <Button
                  type="submit"
                  label="Assign"
                  bgColor='primary'
              fullWidth
                  loading={submitting}
                  disabled={submitting}
                />
              </div>
            </form>
          )}
        </Formik>
      </div>
    </div>
  );
};

export default AssignLead;
